import { useState, useEffect } from 'react';
import Navigation from './components/Navigation';
import HomePage from './pages/HomePage';
import FilmAnalysisPage from './pages/FilmAnalysisPage';
import ScreenplaysPage from './pages/ScreenplaysPage';
import ResearchNotesPage from './pages/ResearchNotesPage';
import VisualEssaysPage from './pages/VisualEssaysPage';
import GraphViewPage from './pages/GraphViewPage';
import DocumentViewer from './components/DocumentViewer';
import './App.css';

function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [documents, setDocuments] = useState({
    analyses: [],
    screenplays: [],
    notes: [],
    essays: []
  });

  // Handle file uploads
  const handleFileUpload = (files, category) => {
    const newDocs = Array.from(files).map(file => ({
      id: Date.now() + Math.random(),
      name: file.name,
      file: file,
      type: file.name.split('.').pop(),
      category,
      uploadDate: new Date().toISOString(),
      links: []
    }));

    setDocuments(prev => ({
      ...prev,
      [category]: [...prev[category], ...newDocs]
    }));
  };

  // Parse internal links from content
  const parseLinks = (content) => {
    const linkRegex = /\[\[(.*?)\]\]/g;
    const matches = content.matchAll(linkRegex);
    return Array.from(matches).map(match => match[1]);
  };

  const renderPage = () => {
    if (selectedDocument) {
      return (
        <DocumentViewer
          document={selectedDocument}
          onClose={() => setSelectedDocument(null)}
          documents={documents}
          onNavigate={setSelectedDocument}
        />
      );
    }

    switch (currentPage) {
      case 'home':
        return <HomePage onNavigate={setCurrentPage} documents={documents} />;
      case 'analyses':
        return (
          <FilmAnalysisPage
            documents={documents.analyses}
            onUpload={(files) => handleFileUpload(files, 'analyses')}
            onSelect={setSelectedDocument}
          />
        );
      case 'screenplays':
        return (
          <ScreenplaysPage
            documents={documents.screenplays}
            onUpload={(files) => handleFileUpload(files, 'screenplays')}
            onSelect={setSelectedDocument}
          />
        );
      case 'notes':
        return (
          <ResearchNotesPage
            documents={documents.notes}
            onUpload={(files) => handleFileUpload(files, 'notes')}
            onSelect={setSelectedDocument}
          />
        );
      case 'essays':
        return (
          <VisualEssaysPage
            documents={documents.essays}
            onUpload={(files) => handleFileUpload(files, 'essays')}
            onSelect={setSelectedDocument}
          />
        );
      case 'graph':
        return <GraphViewPage documents={documents} onNavigate={setSelectedDocument} />;
      default:
        return <HomePage onNavigate={setCurrentPage} documents={documents} />;
    }
  };

  return (
    <div className="app">
      <Navigation
        currentPage={currentPage}
        onNavigate={setCurrentPage}
        showBack={selectedDocument !== null}
        onBack={() => setSelectedDocument(null)}
      />
      <main className="main-content">
        {renderPage()}
      </main>
    </div>
  );
}

export default App;
